import React from 'react';
import { Link } from "react-router-dom";
import paths from '../../routes/paths';
import { imageCodes } from '../../template_codes/phyohandmade/contact_page_codes';

export default function Contact() {
    return (
        <React.Fragment>
            <div className="lg:text-center xl:text-center pl-10 lg:pl-0 xl:pl-0 2xl:pl-0 pt-20">
                <h1 className="text-xl lg:text-4xl xl:text-4xl font-semibold pb-10 pt-10">Contact Us</h1>
                <ul className="list-none">
                    <li className="pb-8">
                        <p className="text-lg pt-2 lg:text-xl xl:text-xl font-bold">Email</p>
                        <p className="text-lg pt-2 lg:text-xl xl:text-xl">phyohandmade.mm@gmail.com</p>
                    </li>
                    <li className="pb-8">
                        <p className="text-lg pt-2 lg:text-xl xl:text-xl font-bold">Phone</p>
                        <p className="text-lg pt-2 lg:text-xl xl:text-xl">09-78-5192124</p>
                    </li>
                    <li className="pb-8">
                        <p className="text-lg pt-2 lg:text-xl xl:text-xl font-bold">Location</p>
                        <p className="text-lg pt-2 lg:text-xl xl:text-xl">Yangon, Myanmar</p>
                    </li>
                    <li className="pb-8">
                        <p className="text-lg pt-2 lg:text-xl xl:text-xl font-bold">Facebook</p>
                        <p className="text-sm pt-2 lg:text-xl xl:text-xl"><a href='https://www.facebook.com/phyohandmade.mm'>https://www.facebook.com/phyohandmade.mm</a></p>
                    </li>

                </ul>
                <div className='container grid grid-cols-1 lg:grid-cols-3 xl:grid-cols-3 pb-20'>
                    <div></div>
                    <div className='place-item-center pl-0 lg:pl-40 xl:pl-40 2xl:pl-40'>
                        <img src={imageCodes.Qr.image} ></img></div>
                    <div></div>
                </div>
            </div>
        </React.Fragment>
    );
}
